
    var formField = document.querySelector("#device_issue_description");
  console.log(formField)
    var addToCartButton = document.querySelector(".product-form__submit");
    if (formField !== undefined && formField !== null && formField !== 'null') {
      console.log('yes')
       addToCartButton.disabled = true;
      formField.addEventListener("change", function() {
      
          if (formField.value.trim() === "") {
              addToCartButton.disabled = true;
          } else {
              addToCartButton.disabled = false;
          }
      });
    }
